$(document).ready(function () {

    var sticky;
    if ($('#onepage-menus').length) {
        if ($(window).width() > 1024) {
            sticky = $('#onepage-menus').offset().top - $('nav').height();
        } else {
            sticky = $('#onepage-menus').offset().top - 131;
        }
    }
    // if($(window).width() > 1024){
    $('#onepage-menus ul li a').onePgaeNav({
        wrapper: '#onepage-menus ul'
    });
    var tabMenuHeight = $('.onepage-menu-block').outerHeight();
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if ($(window).width() < 1024) {
            if ($('.drop-down-tab-links ul li a.active').length) {
                $('.activetab-link').empty().append($('.drop-down-tab-links ul li a.active').html());
            }
        }
        if (scroll >= sticky) {
            $('.onepage-menu-block').addClass('fixed');
            $('#highlights').css('margin-top', tabMenuHeight);
        } else if ($(window).width() > 1024) {
            if (scroll <= sticky - 100) {
                $('.onepage-menu-block').removeClass('fixed');
                $('#highlights').css('margin-top', '0');
            }
        } else if (scroll <= sticky - 20) {
            $('.onepage-menu-block').removeClass('fixed');
            $('#highlights').css('margin-top', '0');
        }
    });

    $('body').on('click', '.activetab-link', function () {
        if ($(this).hasClass('current')) {
            $('.activetab-link').removeClass('current');
            $('.drop-down-tab-links ul').removeClass('active');
        } else {
            $(this).addClass('current');
            $(this).next('.drop-down-tab-links ul').addClass('active');
        }
    });

    $('body').on('click', '.drop-down-tab-links ul li a', function () {
        $('.activetab-link').empty().append($(this).html());
        $('.drop-down-tab-links ul').removeClass('active');
        $('.activetab-link').removeClass('current');
        $('.section-block').removeClass('active');
        var id = $(this).attr('href');
        $(id).addClass('active');
    });
});